module.exports = __webpack_public_path__ + "img/grill-bratwurst-pommes.63ddcec6.png";